
<template>
  <section v-if="loaded">
    <!-- HEADER -->
    <v-toolbar>
      <h1>Display the Banner on pages</h1>
      <v-spacer />
      <v-btn color="success"
        @click.native="saveDisplaySettings"
        :disabled="!isWriteAvailable"
      >
        Save changes
        <v-icon dark right>save</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- HEADER -->

    <div class="my-3">

    <!-- DISPLAY SETTINGS -->
    <v-expansion-panel>
      <v-expansion-panel-content
        v-for="(page, indexPage) in pageInfoList"
        :key="`page-${page.name}-${indexPage}`"
        expand-icon="false"
        >
          <div slot="header" class="my-4">
          <v-layout>
            <v-flex xs4>
              <h3>{{ page.pageName }}</h3>
            </v-flex>

            <v-flex xs5 offset-xs1>
              <content-field
                v-if="showBannerInterval(page.pageName)"
                v-model="page.rowInterval"
                label="Banners interval"
              ></content-field>
            </v-flex>

            <v-flex xs4 offset-xs1>
              <v-select
                label= "Select Banner"
                v-model="page.bannerId"
                :items="getBannersList"
                item-text="metadataObject.description"
                item-value="id"
              />
            </v-flex>
            <v-flex xs2 offset-xs1>
              <v-tooltip
              >
                <v-btn
                  fab flat
                  color="info"
                  slot="activator"
                  @click="openModal(page)"
                >
                  <v-icon>add_box</v-icon>
                </v-btn>
                <span>Add script to page</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs4 offset-xs1>
              <v-list-tile-action>
                <v-layout>
                  <v-flex xs9 class="my-2">
                    <v-switch
                      v-model="page.status"
                      :disabled="!page.bannerId"
                      :label="page.status"
                      true-value="Enabled"
                      false-value="Disabled"
                      @change="saveDisplaySettings"
                    />
                  </v-flex>
                </v-layout>
              </v-list-tile-action>
            </v-flex>
          </v-layout>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
      <!-- DISPLAY SETTINGS -->
    </div>
    <v-dialog persistent max-width="600px" v-model="isModalVisible">
      <v-card>
        <v-card-title v-if="pageInfo">
          <span class="headline">Code for {{pageInfo.pageName}}: </span>
          <div>
            <content-editor
              v-model="pageInfo.customScript"
            />
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="error" dark large @click.stop="closeModal">Cancel</v-btn>
          <v-btn color="success" dark large @click.stop="saveDisplaySettings">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import GalleriesList from '@/components/pages/Gallery/GalleriesList'
import ContentField from '@/components/shared/ContentField/index.vue'
import { equals, clone, pathOr } from 'ramda'
import { timeSettings } from '@/modules/settings/'
import { mapActions, mapGetters } from 'vuex'
import mixins from '@/utils/mixins'

export default {
  name: 'BannersDisplay',
  mixins: [mixins.isWriteAvailable],
  components: {
    ContentField,
    GalleriesList
  },
  data () {
    return {
      isModalVisible: false,
      selectBanners: '',
      pageInfo: null,
      loaded: false,
      filterInput: '',
      pagination: {
        rowsPerPage: 5
      },
      modalWindow: false,
      modalGallery: false,
      pageWhereBannerCanBeAttach:[
        'home',
        'about',
        'attendees',
        'business-booster',
        'sponsors',
        'speakers',
        'agenda',
        'awards-welcome',
        'venue',
        'hotel-info',
        'networking-blitz',
        'photo-gallery',
        'agenda',
        'floor-plan',
        'videos',
        'contact-us'
      ],
      formData: {
        bannerSettings: {
          pageWithBanner: []
        }
      },
      fetchPageBannerInfo: '',
      isEditedItem: false,
      pageInfoList: [],
      //  DON'T DELETE! need for isWriteAvailable mixin

      scopeForWrite: 'awards:write'
    }
  },
  computed: {
    ...mapGetters([
      'getBannersList',
      'getBannerById',
      'getPageInfoBanner'
    ])
  },
  methods: {
    ...mapActions([
      'fetchBanners',
      'showResultErrorMessage',
      'savePageWithBanner',
      'fetchPageWithBanner'
    ]),
    openModal(page) {
      this.pageInfo = page
      this.isModalVisible = true
    },
    closeModal () {
      this.pageInfo = null
      this.isModalVisible = false
    },
    showBannerInterval(pageName) {
      return pageName === 'attendees' || pageName === 'networking-blitz' || pageName === 'photo-gallery'
    },
    saveDisplaySettings () {
      const payload = {
        bannerSettings: {
          pageWithBanner: this.pageInfoList
        }
      }
      this.savePageWithBanner(payload)
    },
    setPageInfoList (fetchedBanners) {
      const initialBannersSettings = this.pageWhereBannerCanBeAttach.reduce((pageInfoList, pageName) => {
        pageInfoList.push({
          pageName,
          bannerId: null,
          rowInterval: '',
          status: 'Disabled',
          customScript: ''
        })
        return pageInfoList
      }, [])

      const filteredFetchedBanners = fetchedBanners.filter(item => item.bannerId && this.getBannerById(item.bannerId))

      this.pageInfoList = initialBannersSettings.map(pageInfo => {
        const pageWhichExistsOnBe = filteredFetchedBanners.find(pageInfoFromBe => pageInfoFromBe.pageName === pageInfo.pageName)

        return !!pageWhichExistsOnBe
          ? pageWhichExistsOnBe
          : pageInfo
      })
    }
  },
  async created () {
    await this.fetchPageWithBanner()
    await this.fetchBanners()
    this.setPageInfoList(this.getPageInfoBanner)
    this.loaded = true
  }
}
</script>

<style type="scss">
.arrow {
  margin: 0 -10px;
}

.arrow i {
  font-size: 16px;
}

.selected-color-box {
  display: inline-block;
  width: 27px;
  height: 27px;
  margin-left: 10px;
  border-radius: 2px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Banners/Display/index.vue